import { Quote } from "lucide-react";

const items = [
  {
    quote:
      "Aadiyogis have become our default sourcing partner for turmeric and cardamom. In four years we've had zero contract disputes.",
    name: "Farid Al-Mansoori",
    role: "Procurement Head, Emirates Spice Co.",
    country: "Dubai, UAE",
  },
  {
    quote:
      "Their traceability documentation meets EU standards without a single follow-up. That's rare in this industry.",
    name: "Ines Vogel",
    role: "Category Buyer, Grüne Handel GmbH",
    country: "Hamburg, DE",
  },
  {
    quote:
      "Reliable Basmati at reliable margins. That is the entire summary of working with this team.",
    name: "Nguyen Thanh Long",
    role: "Director, Saigon Grain Trading",
    country: "Ho Chi Minh City, VN",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14 reveal">
          <p className="overline">Buyer voices</p>
          <h2 className="mt-4 font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1A3626] leading-tight tracking-tight">
            Trusted by importers<br />across three decades.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-[#1A3626]/10 p-8 md:p-10 hover:border-[#C5A059] transition-colors duration-300 reveal"
            >
              <Quote size={32} strokeWidth={1} className="text-[#C5A059]" />
              <p className="mt-6 font-serif-display text-xl md:text-2xl text-[#1A3626] leading-snug italic">
                “{t.quote}”
              </p>
              <div className="mt-8 pt-6 border-t border-[#1A3626]/10">
                <div className="font-medium text-[#1A3626]">{t.name}</div>
                <div className="text-sm text-[#4B5563] mt-1">{t.role}</div>
                <div className="overline mt-2 text-[#C5A059]">{t.country}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
